module.exports = __webpack_public_path__ + "static/media/em-39.2f9e82a2.png";